const React = require('react');
const DownloadIcon = require('@material-ui/icons/GetApp').default;
const {
  getKYCDocDownloadLinkById,
} = require('../../../../api/admin/accountsKYC');


module.exports = (props) => {
  const data = props.data || {};
  const id = data.id || '';
  const fileName = data.file_name || id;

  return id ? (
    <a
      className="layoutRow fhaS fvaC olN tdN cF dn o70:h"
      download={fileName}
      target="_blank"
      href={getKYCDocDownloadLinkById(id)}
      rel="noreferrer"
    >
      <DownloadIcon className="sq18*2 ml-2"/>
      <div className="pl5 wmin0 fx1 ov tov wsNW">
        {fileName}
      </div>
    </a>
  ) : '-';
};
